<template>
  <!--
    ВРЕМЕННАЯ ПАНЕЛЬ. Шаг 1.6 из docs/push-notifications-plan.md: до появления
    модалки после логина разрешение запросить неоткуда, а запрашивать его можно
    только по нажатию. Уходит вместе с рубежом 2 — удалить файл и две строки в
    UserProfile.vue. Строки зашиты намеренно: в локалях после удаления мусора
    не останется.
  -->
  <up-card>
    <div class="push-debug">
      <div class="push-debug__state">
        <span class="push-debug__title">Push-уведомления</span>
        <span class="push-debug__value">{{ stateText }}</span>
      </div>

      <p
        v-if="endpoint"
        class="push-debug__endpoint"
      >
        {{ endpoint }}
      </p>

      <div class="push-debug__actions">
        <button
          type="button"
          class="push-debug__btn"
          :disabled="busy"
          @click="enable"
        >
          Разрешить и подписаться
        </button>
        <button
          v-if="endpoint"
          type="button"
          class="push-debug__btn push-debug__btn--ghost"
          :disabled="busy"
          @click="disable"
        >
          Отписаться
        </button>
      </div>

      <p
        v-if="message"
        class="push-debug__message"
      >
        {{ message }}
      </p>
    </div>
  </up-card>
</template>

<script>
import push, { PUSH_API_READY } from '@/components/mixins/methodsPush';

export default {
  name: 'PushDebugCard',
  mixins: [push],
  data() {
    return {
      permission: 'default',
      endpoint: '',
      message: '',
      busy: false,
    };
  },
  computed: {
    stateText() {
      if (!this.pushSupported()) return 'браузер не поддерживает';

      const permissions = {
        granted: 'разрешено',
        denied: 'запрещено',
        default: 'не спрашивали',
      };

      return `${permissions[this.permission]}, ${this.endpoint ? 'подписка есть' : 'подписки нет'}`;
    },
  },
  mounted() {
    this.refresh();
  },
  methods: {
    refresh() {
      this.permission = this.pushPermission();

      return this.currentPushSubscription()
        .then((subscription) => {
          this.endpoint = subscription ? subscription.endpoint : '';
        });
    },
    enable() {
      this.busy = true;
      this.message = '';

      return this.requestPushPermission()
        .then((permission) => {
          this.permission = permission;

          if (permission !== 'granted') {
            this.message = permission === 'denied'
              ? 'Запрещено. Снять можно только в настройках сайта.'
              : 'Разрешение не выдано.';
            return false;
          }

          return this.subscribePush();
        })
        .then((sent) => {
          if (sent) this.message = 'Подписка создана и отправлена на сервер.';
          else if (this.permission === 'granted' && !PUSH_API_READY) {
            this.message = 'Разрешение есть, но PUSH_API_READY выключен — сервер не готов.';
          }

          return this.refresh();
        })
        .finally(() => {
          this.busy = false;
        });
    },
    disable() {
      this.busy = true;
      this.message = '';

      return this.unsubscribePush()
        .then(() => {
          this.message = 'Подписка снята.';
          return this.refresh();
        })
        .finally(() => {
          this.busy = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.push-debug {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 4px 0;
}

.push-debug__state {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.push-debug__title {
  font-weight: 600;
}

.push-debug__value {
  font-size: 13px;
  color: #6b6b6b;
}

.push-debug__endpoint {
  margin: 0;
  font-size: 11px;
  line-height: 1.3;
  color: #9a9a9a;
  word-break: break-all;
}

.push-debug__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.push-debug__btn {
  padding: 8px 12px;
  font-size: 13px;
  color: #fff;
  background: #cf3c00;
  border: 1px solid #cf3c00;
  border-radius: 6px;
  cursor: pointer;

  &:disabled {
    opacity: 0.5;
    cursor: default;
  }
}

.push-debug__btn--ghost {
  color: #cf3c00;
  background: transparent;
}

.push-debug__message {
  margin: 0;
  font-size: 13px;
}
</style>
